import { staticRoutes } from '@atlas/routing';

import { SMARTICO_STORE } from 'components/MainRouter/constants';

// Canonical Smartico Store URL ('/account/store', matches akira). The page is
// rendered standalone by an explicit route in `MainRouter.js`.
export const SMARTICO_STORE_PATH = staticRoutes.smarticoStore;

export { SMARTICO_STORE };
